import type {
  CreateLifecycleChecklistItemRequest,
  LifecycleChecklistItemDto,
  UpdateLifecycleChecklistItemRequest,
} from '@ledokol/contracts'
import { api } from './client'

/** #10 — чеклисты стадий лайфцикла. Видимость — scope проекта; действия — права. */
const base = (projectId: string) => `/projects/${projectId}/lifecycle/checklist`

export async function fetchLifecycleChecklist(projectId: string): Promise<LifecycleChecklistItemDto[]> {
  const r = await api.get<LifecycleChecklistItemDto[]>(base(projectId))
  return r.data
}
export async function createChecklistItem(projectId: string, body: CreateLifecycleChecklistItemRequest): Promise<LifecycleChecklistItemDto> {
  const r = await api.post<LifecycleChecklistItemDto>(base(projectId), body)
  return r.data
}
export async function updateChecklistItem(projectId: string, itemId: string, body: UpdateLifecycleChecklistItemRequest): Promise<LifecycleChecklistItemDto> {
  const r = await api.patch<LifecycleChecklistItemDto>(`${base(projectId)}/${itemId}`, body)
  return r.data
}
export async function deleteChecklistItem(projectId: string, itemId: string): Promise<void> {
  await api.delete(`${base(projectId)}/${itemId}`)
}
export async function toggleChecklistItem(projectId: string, itemId: string, isDone: boolean): Promise<LifecycleChecklistItemDto> {
  const r = await api.post<LifecycleChecklistItemDto>(`${base(projectId)}/${itemId}/toggle`, { is_done: isDone })
  return r.data
}
